export default __webpack_public_path__ + "b66d915d43ee6c7aab0d52b7780484a3.png";